<template>
    <div class="accountData">
        <Page showAdd showAddText="新增账号" :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch" @add="handleClickAdd">
            <div class="table-content" ref="tableContent" :style="`height: ${tableHeight}px`">
                <Table :data="tableData" size="medium" stripe v-if="tableData.length && !isLoading" :height="tableHeight">
                    <el-table-column prop="name" label="账号名称" min-width="60"></el-table-column>
                    <el-table-column prop="email" label="登录账号" min-width="60"></el-table-column>
                    <el-table-column prop="customerName" label="所属客户" min-width="60"></el-table-column>
                    <el-table-column prop="userRoleName" label="账号角色" min-width="30"></el-table-column>
                    <el-table-column prop="status" label="状态" min-width="30">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #67c23a; font-size: 12px;" v-if="scope.row.status == 1">正常</span>
                                <span style="color: #FF003C; font-size: 12px;" v-else-if="scope.row.status == 2">停止登录</span>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号" min-width="60"></el-table-column>
                    <el-table-column prop="notes" label="备注" min-width="60"></el-table-column>
                    <el-table-column prop="adReportOrderStatus" label="操作" width="72">
                        <template slot-scope="scope">
                            <div class="table-edit" @click="handleEdit(scope.row)">
                                <img src="../../../../assets/home/userInfo/customerManage/edit_select.png" alt="">
                                <span>编辑</span>
                                <!-- {{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}} -->
                            </div>
                        </template>
                    </el-table-column>
                </Table>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <Loading></Loading>
                </div>
            </div>
        </Page>

        <Dialog v-model="isShow" :title="title" @cancel="handleCancel" @confirm="handleConfirm">
            <div class="accountData-form">
                <Form ref="customerManage-form" :renderList="formRenderList" v-model="addFormData" :rules="formRules"></Form>
            </div>
        </Dialog>

        <div :class="`accountData-mobile`">
            <PageMobile title="账号管理" :renderSearchList="renderMobileList" :searchData="searchData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch" showAdd addText="新增账号" @add="handleClickAdd">
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading">
                        <el-table-column prop="name" label="账号名称" width="120"></el-table-column>
                        <el-table-column prop="email" label="登录账号" width="150"></el-table-column>
                        <el-table-column prop="customerName" label="所属客户" width="120"></el-table-column>
                        <el-table-column prop="userRoleName" label="账号角色" width="80"></el-table-column>
                        <el-table-column prop="status" label="状态" width="72">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #67c23a; font-size: 12px;" v-if="scope.row.status == 1">正常</span>
                                    <span style="color: #FF003C; font-size: 12px;" v-else-if="scope.row.status == 2">停止登录</span>
                                    <span v-else>--</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
                        <el-table-column prop="notes" label="备注" width="120"></el-table-column>
                        <el-table-column prop="adReportOrderStatus" label="操作" width="72">
                            <template slot-scope="scope">
                                <div class="table-edit" @click="handleEdit(scope.row)">
                                    <img src="../../../../assets/home/userInfo/customerManage/edit_select.png" alt="">
                                    <span>编辑</span>
                                    <!-- {{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}} -->
                                </div>
                            </template>
                        </el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <Loading></Loading>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Page from '@/components/page/page.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
import Dialog from '@/components/dialog/dialog.vue'
import Form from '@/components/form/form.vue'
import Icon from 'iview/src/components/icon';
import { Table, TableColumn } from 'element-ui';
import Loading from '@/components/loading/loading.vue'
import { Message } from 'iview'
Vue.use(Table)
Vue.use(TableColumn)
import { renderList, renderMobileList, formRenderList, formRules } from './config'
import moment from 'moment'
export default {
    components: {
        Page,
        Icon,
        Table,
        Loading,
        PageMobile,
        Dialog,
        Form
    },
    data() {
        return {
            renderList: renderList,
            formRenderList: formRenderList,
            renderMobileList: renderMobileList,
            tableData: [],
            searchData: {},
            isLoading: true,
            tableTotalData: {},
            total: 0,
            pageSize: 15,
            current: 1,
            tableHeight: "",
            addFormData: {},
            isShow: false,
            formRules: formRules,
            title: '新增账号'
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '-'
            }
        }
    },
    mounted() {
        this.tableHeight = this.$refs.tableContent ? (this.$refs.tableContent.offsetHeight ? this.$refs.tableContent.offsetHeight : 480) : ""
        if (window.innerWidth > 768) {
            this.tableHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : ""
        } else {
            this.tableHeight = this.$refs.tableContentMobile ? this.$refs.tableContentMobile.offsetHeight : ""
        }
        this.initData()
        this.getTableData()
    },
    methods: {
        // 初始化页面数据
        initData() {
            Promise.all([this.getAllRole(), this.getAllCustomer()]).then((result) => {
                const customerList = result[1].map((item) => {
                    return {
                        label: item.name,
                        value: item.customerId
                    }
                })
                const roleList = result[0].map((item) => {
                    return {
                        label: item.roleName,
                        value: item.roleId
                    }
                })
                this.$set(this.formRenderList[3], 'options', customerList)
                this.$set(this.formRenderList[4], 'options', roleList)
                // formRenderList[3].options = result[1].map((item) => {
                //     return {
                //         label: item.name,
                //         value: item.customerId
                //     }
                // })
                // formRenderList[4].options = result[0].map((item) => {
                //     return {
                //         label: item.roleName,
                //         value: item.roleId
                //     }
                // })
            }).catch(() => {
                this.formRenderList = formRenderList
            })
        },

        // 获取所有角色列表
        getAllRole() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/userRole/all',
                    data: {
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.data)
                })
            })
        },

        // 获取所有客户
        getAllCustomer() {
            return new Promise((resolve, reject) => {
                this.$axios({
                    url: '/api/syn/rebateDataPlat/customer/all',
                    data: {
                    },
                    method: 'GET'
                }).then((res) => {
                    resolve(res.Data)
                })
            })
        },

        // 获取商品数据
        getTableData() {
            this.isLoading = true
            this.$axios({
                url: '/api/syn/rebateDataPlat/list',
                data: {
                    ...this.searchData,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'POST'
            }).then((res) => {
                this.tableData = res.Data.data || []
                this.total = res.Data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            })
        },

        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            delete currData.dates
            this.searchData = {
                ...currData
            }
        },

        // 处理取消新增/编辑账号事件
        handleCancel() {
            this.$refs['customerManage-form'].$refs['wf-form'].resetFields()
            this.isShow = false
        },

        // 处理点击编辑事件
        handleEdit(item) {
            // const passwordRules = [...this.formRules.password]
            // passwordRules[0].required = false
            this.$set(this.formRules.password[0], 'required', false)
            formRenderList[2].placeholder = "******"
            formRenderList[3].disabled = true
            this.formRenderList = formRenderList
            this.title = "编辑账号"
            this.addFormData = item
            this.isShow = true
        },

        // 处理确定新增/编辑账号事件
        handleConfirm() {
            this.$refs['customerManage-form'].$refs['wf-form'].validate((valid) => {
                if (valid) {
                    const params = {
                        name: this.addFormData.name,
                        email: this.addFormData.email,
                        customerId: this.addFormData.customerId,
                        userRoleId: this.addFormData.userRoleId,
                        phone: this.addFormData.phone,
                        notes: this.addFormData.notes,
                        status: this.addFormData.status
                    }
                    if (this.addFormData.password) {
                        params.password = window.md5(this.addFormData.password)
                    }
                    if (this.addFormData.id) {   //  编辑
                        this.$axios({
                            url: '/api/syn/rebateDataPlat/update',
                            data: {
                                id: this.addFormData.id,
                                ...params
                            },
                            method: 'POST'
                        }).then((res) => {
                            this.handleCancel()
                            this.getTableData()
                            Message.success('编辑账号成功')
                        })
                    } else {
                        this.$axios({
                            url: '/api/syn/rebateDataPlat/add',
                            data: {
                                ...params
                            },
                            method: 'POST'
                        }).then((res) => {
                            this.handleCancel()
                            this.getTableData()
                            Message.success('新增账号成功')
                        })
                    }
                }
            })
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.getTableData()
        },

        // 点击新增按钮时触发
        handleClickAdd() {
            this.$set(this.formRules.password[0], 'required', true)
            formRenderList[2].placeholder = "请输入密码"
            formRenderList[3].disabled = false
            this.formRenderList = formRenderList
            this.addFormData = {}
            this.title = "新增账号"
            this.isShow = true
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.getTableData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.getTableData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .accountData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .accountData-mobile {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-form {
            padding: 0 40px;
        }
        .accountData-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .table-edit {
            display: inline-flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            > img {
                width: 12px;
                height: 12px;
                margin-right: 7px;
            }
            > span {
                font-size: 12px;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .accountData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            overflow-y: auto;
            .table-content {
                overflow-x: auto;
            }
        }
        .accountData-form {
            padding: 0 0.4rem;
        }
        .table-edit {
            > img {
                width: 0.26rem;
                height: 0.26rem;
                margin-right: 7px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/userInfo/accountManage/index.vue